import { useRef } from "react";
import useImagesLoaded from "../../hooks/useImagesLoaded";

import AviatricsHero from "../../components/About/AboutHero1";
import Timelinesection from "../../components/Timelinesection/Timelinesection";
import ServicesSection from "../../components/About/ServicesSection";
import GrowthPriorities from "../../components/About/GrowthPriorities";
import Contact from "../../components/Contact/Contact";

export default function AboutPage() {
    const containerRef = useRef(null);
    useImagesLoaded(containerRef);

    return (
        <main
            ref={containerRef}
            style={{ background: "#05050f", minHeight: "100vh", overflowX: "hidden" }}
        >
            <AviatricsHero />
            <Timelinesection />
            <ServicesSection />
            <GrowthPriorities />
            <Contact />
        </main>
    );
}